/**
 * Constantes relacionadas à paginação
 */

// Opções de itens por página disponíveis
export const ITEMS_PER_PAGE_OPTIONS = [5, 10, 20, 50, 100];

// Valor padrão de itens por página
export const DEFAULT_ITEMS_PER_PAGE = 10;

// Número mínimo de páginas para mostrar reticências
export const MIN_PAGES_FOR_ELLIPSIS = 4; 